import React, { useState, useEffect, createContext, useContext } from 'react';

const UserDeviceContext = createContext();

const UserDeviceProvider = (props) => {
    const [deviceInfo, setDeviceInfo] = useState('');

    useEffect(() => {
        const getBrowserInfo = () => {
            const osPatterns = [
                { name: 'Windows Phone', value: 'Windows Phone', version: 'OS' },
                { name: 'Windows', value: 'Win', version: 'NT' },
                { name: 'iPhone', value: 'iPhone', version: 'OS' },
                { name: 'iPad', value: 'iPad', version: 'OS' },
                { name: 'Kindle', value: 'Silk', version: 'Silk' },
                { name: 'Android', value: 'Android', version: 'Android' },
                { name: 'PlayBook', value: 'PlayBook', version: 'OS' },
                { name: 'BlackBerry', value: 'BlackBerry', version: '/' },
                { name: 'Macintosh', value: 'Mac', version: 'OS X' },
                { name: 'Linux', value: 'Linux', version: 'rv' },
                { name: 'Palm', value: 'Palm', version: 'PalmOS' }
            ];

            const browserPatterns = [
                { name: 'Chrome', value: 'Chrome', version: 'Chrome' },
                { name: 'Firefox', value: 'Firefox', version: 'Firefox' },
                { name: 'Safari', value: 'Safari', version: 'Version' },
                { name: 'Internet Explorer', value: 'MSIE', version: 'MSIE' },
                { name: 'Opera', value: 'Opera', version: 'Opera' },
                { name: 'BlackBerry', value: 'CLDC', version: 'CLDC' },
                { name: 'Mozilla', value: 'Mozilla', version: 'Mozilla' }
            ];

            const matchItem = (userAgent, patterns) => {
                for (let i = 0; i < patterns.length; i++) {
                    const regex = new RegExp(patterns[i].value, 'i');
                    if (!regex.test(userAgent)) continue;

                    const versionRegex = new RegExp(patterns[i].version + '[- /:;]([\\d._]+)', 'i');
                    const versionMatch = userAgent.match(versionRegex);
                    let version = '0';

                    if (versionMatch && versionMatch[1]) {
                        const parts = versionMatch[1].split(/[._]+/);
                        version = parts[0] + '.' + parts.slice(1).join('');
                    }

                    return { name: patterns[i].name, version: parseFloat(version) };
                }
                return { name: 'unknown', version: 0 };
            };

            const agent = navigator.userAgent;
            return {
                os: matchItem(agent, osPatterns),
                browser: matchItem(agent, browserPatterns)
            };
        };

        const realWidth = window.screen.width * window.devicePixelRatio;
        const realHeight = window.screen.height * window.devicePixelRatio;
        const info = getBrowserInfo();

        setDeviceInfo(
            `os.name = ${info.os.name}, os.version = ${info.os.version}, ` +
            `browser.name = ${info.browser.name}, browser.version = ${info.browser.version}, ` +
            `dimensions: ${realWidth} x ${realHeight}`
        );
    }, []);

    return (
        <UserDeviceContext.Provider value={{ deviceInfo, setDeviceInfo }}>
            {props.children}
        </UserDeviceContext.Provider>
    );
};

export const useDeviceInfo = () => {
    const context = useContext(UserDeviceContext);
    if (context === undefined) {
        throw new Error('useDeviceInfo must be used within a UserDeviceProvider');
    }
    return context;
};

export default UserDeviceProvider;
